import { fetchApi } from 'shared/functions';

export const fetchIndustries = () =>
  fetchApi(`/storefront/classification-standards/TnR/industries`)
    .then(response => response.json())
    .then(({ data }) => data);
